var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$t("kelaBatch.title")) + " "),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: { small: "" },
              on: {
                click: function($event) {
                  _vm.searchDialog = true
                }
              }
            },
            [
              _c("v-icon", { attrs: { left: "", small: "" } }, [
                _vm._v("mdi-magnify")
              ]),
              _vm._v(" " + _vm._s(_vm.$t("kelaBatch.search")) + " ")
            ],
            1
          ),
          _c(
            "v-btn",
            {
              attrs: { icon: "", small: "", loading: _vm.loading },
              on: { click: _vm.refresh }
            },
            [_c("v-icon", [_vm._v("mdi-refresh")])],
            1
          )
        ],
        1
      ),
      _vm.batches.length > 0
        ? _c("v-card-subtitle", [
            _c(
              "span",
              { staticClass: "mr-4" },
              [
                _c("v-icon", { attrs: { small: "", color: "grey" } }, [
                  _vm._v("mdi-clock-outline")
                ]),
                _vm._v(" " + _vm._s(_vm.$t("kelaBatch.waitingCount")) + ": "),
                _c("strong", [_vm._v(_vm._s(_vm.pendingCount))])
              ],
              1
            ),
            _c(
              "span",
              { staticClass: "mr-4" },
              [
                _c("v-icon", { attrs: { small: "", color: "green" } }, [
                  _vm._v("mdi-check-circle-outline")
                ]),
                _vm._v(" " + _vm._s(_vm.$t("kelaBatch.processedCount")) + ": "),
                _c("strong", [_vm._v(_vm._s(_vm.processedCount))])
              ],
              1
            ),
            _c(
              "span",
              [
                _c("v-icon", { attrs: { small: "", color: "orange" } }, [
                  _vm._v("mdi-alert-circle-outline")
                ]),
                _vm._v(" " + _vm._s(_vm.$t("kelaBatch.otherCount")) + ": "),
                _c("strong", [_vm._v(_vm._s(_vm.otherCount))])
              ],
              1
            )
          ])
        : _vm._e(),
      _c("v-data-table", {
        staticClass: "clickable-rows",
        attrs: {
          headers: _vm.tableHeaders,
          items: _vm.batches,
          "server-items-length": _vm.totalCount,
          options: _vm.tableOptions,
          loading: _vm.loading,
          "footer-props": { itemsPerPageOptions: [25, 50, 100] }
        },
        on: {
          "update:options": function($event) {
            _vm.tableOptions = $event
          },
          "click:row": _vm.selectBatch
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item.sentAt",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm._v(" " + _vm._s(_vm.formatDateTime(item.sentAt)) + " ")
                ]
              }
            },
            {
              key: "item.totalCost",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm._v(" " + _vm._s(_vm.formatCurrency(item.totalCost)) + " ")
                ]
              }
            },
            {
              key: "item.totalReimbursement",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatCurrency(item.totalReimbursement)) +
                      " "
                  )
                ]
              }
            },
            {
              key: "item.feedbackStatus",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "v-chip",
                    {
                      attrs: {
                        small: "",
                        color: _vm.feedbackStatusColor(item.feedbackStatus),
                        dark: ""
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.feedbackStatusLabel(item.feedbackStatus)) +
                          " "
                      )
                    ]
                  )
                ]
              }
            },
            {
              key: "item.settlementReceivedAt",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "v-chip",
                    {
                      attrs: {
                        small: "",
                        color: item.settlementReceivedAt ? "green" : "grey",
                        dark: ""
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.settlementReceivedAt
                              ? _vm.$t("kelaBatch.settlementReceived")
                              : _vm.$t("kelaBatch.feedbackPending")
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              }
            },
            {
              key: "item.containsCombinedTrips",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        small: "",
                        color: item.containsCombinedTrips
                          ? "primary"
                          : "grey lighten-2"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.containsCombinedTrips
                              ? "mdi-call-merge"
                              : "mdi-minus"
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              }
            },
            _vm.batches.length > 0
              ? {
                  key: "body.append",
                  fn: function() {
                    return [
                      _c(
                        "tr",
                        { staticClass: "font-weight-bold grey lighten-4" },
                        [
                          _c("td", { attrs: { colspan: "6" } }),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.formatCurrency(_vm.totalCostSum)))
                          ]),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatCurrency(_vm.totalReimbursementSum)
                              )
                            )
                          ]),
                          _c("td", { attrs: { colspan: "3" } })
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        )
      }),
      _c("kela-batch-search-dialog", {
        attrs: { "current-params": _vm.currentSearchParams },
        on: { search: _vm.onSearch },
        model: {
          value: _vm.searchDialog,
          callback: function($$v) {
            _vm.searchDialog = $$v
          },
          expression: "searchDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }